var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLeaderboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.222656 8.24508L7.45055 0.467218C7.75427 0.140484 8.2466 0.140484 8.55032 0.467218L15.7782 8.24508H14.2227V13.8297C14.2227 14.2919 13.8744 14.6666 13.4449 14.6666H11.5004H9.55599V9.919H6.44488V14.6666H2.55599C2.12643 14.6666 1.77821 14.2919 1.77821 13.8297V8.24508H0.222656Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeaderboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leaderboard.ec2d02db.svg";
export { ForwardRef as ReactComponent };